/**
 * The StockX product id stored on a product-fetch row, or null when the fetch
 * never completed (a first PENDING row, or one that failed before it wrote one).
 * The queue keys its rows by the vendor's url key, and the product page reads
 * StockX by product id, so this is the only way from one to the other.
 *
 * Typed off `unknown` rather than the core payload type: tsc gives up
 * ("excessively deep") on the recursive `JsonObject` the moment a component
 * reads through it.
 */
export function stockxProductId(payload: unknown): string | null {
  const market = (payload as { market?: { id?: unknown; uuid?: unknown } } | null | undefined)
    ?.market;
  // First usable one wins, `uuid` first the way the listing mapper reads it: with `??`
  // a blank or non-string `uuid` would hide an `id` that works.
  for (const value of [market?.uuid, market?.id]) {
    const id = typeof value === "string" ? value.trim() : "";
    if (id !== "") return id;
  }
  return null;
}
